package com.starparty.app.astro0.celestialobjects

import com.starparty.app.astro0.SP_Colour
import com.starparty.app.astro0.SP_Time
import com.starparty.app.astro0.UMS

/* Deep-Sky Object */
class DSO (
    t: SP_Time,
    raUMS: UMS,
    decUMS: UMS,
    var visMag: Double,
    var dsoType: String,
    var mesNum: Int,
    name: String

) : CelestialBody(
    UMS.hourMinSecToDecimalDegrees(raUMS.toString()),
    UMS.unitMinSecToDecimal(decUMS),
    name) {

    var mesName: String = ""
        get(){
            return "M$mesNum"
        }

    val DEF_COLOR = SP_Colour(0,255,0,255)

    /** Overrides abstract method in superclass to do nothing.
     * Might in future be used to correct position for proper motion,
     * precession etc.  */
    override fun recalculateEquatorialCoordinates(time: SP_Time) {

    }

    override fun getSearchableObjectType(): String {

        var dsoTypeName = when (dsoType) {
            "OC" -> "open cluster"
            "SG" -> "spiral galaxy"
            "HII" -> "HII nebula"
            "GC" -> "globula cluster"
            "NwC" -> "nebula with cluster"
            "HIIwC" -> "HII nebula with cluster"
            "PN" -> "planetary nebula"
            "BSG" -> "barred spiral galaxy"
            "DEG" -> "dwarf elliptical galaxy"
            "DN" -> "diffuse nebula"
            "SR" -> "supernova remnant"
            "SBG" -> "starburst galaxy"
            "A" -> "asterism"
            "EG" -> "elliptical galaxy"
            "SS" -> "double star"
            "LG" -> "lenticular galaxy"
            else -> ""
        }

        return dsoTypeName
    }

    init {

        recalculateEquatorialCoordinates(t)
        recalculateCartesianCoordinates(t)

        this.rgbColour = DEF_COLOR
        this.name = "${this.mesName}"
        if (name != "") {
            this.name = this.name + " $name"
        } //${getRA_HMSString(3)} ${getDec_DMSString(3)}"
        this.abbrevName = this.mesName
    }
}